import React from 'react';
import { WaitListManagerOrganism } from 'design-system/my-lib';
import './WaitlistSection.scss';

const WaitlistSection: React.FC = () => {
  return (
    <div className="waitlist-section" data-testid="waitlist-section">
      <WaitListManagerOrganism />
    </div>
  );
};

export default WaitlistSection;
